module.exports = __webpack_public_path__ + "fonts/063f63b80a18487346b6bf074d4f094b.woff2";